import React from 'react';
import { Icon } from '@iconify/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';
import reactjsIcon from '@iconify/icons-logos/react';
import { HighlightedTextIcon } from 'components/molecules';

const Text = () => (
    <>
        Ich habe etwa zwei Jahre damit verbracht, meine Fähigkeiten in der{' '}
        <span className="font-bold text-gray-800">Webentwicklung</span> zu verbessern, indem ich{' '}
        <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactjsIcon} />}
        >
            ReactJS
        </HighlightedTextIcon>{' '}
        und{' '}
        <HighlightedTextIcon className="mx-2" icon={<Icon icon={tailwindcssIcon} />}>
            TailwindCSS
        </HighlightedTextIcon>{' '}
        verwendet habe, sodass ich jetzt ziemlich zuversichtlich bin, Apps mit diesen Tools zu erstellen:
    </>
);

const skills = {
    text: <Text />,
};

export default skills;
